import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getBookings = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch bookings");
    return error;
  }
};

export const createBooking = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "bookings",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking created successfully");
    }
    return response;
  } catch (error: any) {
    // toast.error(error.message || "Failed to create booking");
    return error;
  }
};

export const updateBooking = async (id: string | undefined, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking updated successfully");
    }
    return response;
  } catch (error: any) {
    // toast.error(error.message || "Failed to update booking");
    return error;
  }
};

export const deleteBooking = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete booking");
    return error;
  }
};

export const deleteBookingPermanently = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${id}/permanent_delete`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete booking");
    return error;
  }
};

export const restoreBooking = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${id}/restore`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Booking Restored successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to restore booking");
    return error;
  }
};

export const getBookingById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch booking");
    return error;
  }
};

export const getAllBookings = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings?limit=1000`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch bookings");
    return error;
  }
};

export const checkAvailability = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/availability/check`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.holiday_message || error.message || "Failed to fetch bookings");
    return error;
  }
};
 

export const getBookingStatus = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `statuses${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch booking status");
    return error;
  }
}

export const getBookingDocuments = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `forms${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch booking forms");
    return error;
  }
};

export const updateCollectionFrom = async (id, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "bookings/collection_document/" + id,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Collection document updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update collection document");
    return error;
  }
};


export const updateDeliveryFrom = async (id, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "bookings/delivery_document/" + id,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Delivery document updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update delivery document");
    return error;
  }
};

export const sendRentalAgreementEmail = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/rental_agreement/send_email`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Rental Agreement Email sent successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to send rental agreement email");
    return error;
  }
}

export const createBookingCSV = async (csv: any) => {
  let formData = new FormData();
  formData.append('csv', csv);
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "bookings/csv_upload",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData, 
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Bookings created successfully");
    }
    return response;
  } catch (error: any) {
    return error;
  }
};

export const clearBooking = async (id: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/invoice/${id}/clear`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Invoice cleared successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to clear booking");
    return error;
  }
};

export const refundPayment = async (Id: number, data : {charge_id:string; amount: number}) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `bookings/${Id}/refund`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json", 
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Payment refunded successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to refund payment");
    return error;
  }
}